export default __webpack_public_path__ + "static/media/elevate-dmb-3.b45f1ac4.png";